import { PDFName, PDFNumber } from '../core/index.js';
export const asPDFName = (name) => typeof name !== 'string' ? name : PDFName.of(name);
export const asPDFNumber = (num) => typeof num !== 'number' ? num : PDFNumber.of(num);
export const asNumber = (num) => typeof num !== 'number' ? num.asNumber() : num;
export var PDFClasses;
(function (PDFClasses) {
    PDFClasses["PDFDict"] = "PDFDict";
    PDFClasses["PDFObject"] = "PDFObject";
    PDFClasses["PDFNumber"] = "PDFNumber";
    PDFClasses["PDFName"] = "PDFName";
    PDFClasses["PDFStream"] = "PDFStream";
    PDFClasses["PDFWriter"] = "PDFWriter";
    PDFClasses["PDFStreamWriter"] = "PDFStreamWriter";
    PDFClasses["PDFString"] = "PDFString";
    PDFClasses["PDFHexString"] = "PDFHexString";
    PDFClasses["PDFDocument"] = "PDFDocument";
    PDFClasses["PDFPageLeaf"] = "PDFPageLeaf";
    PDFClasses["StandardFontEmbedder"] = "StandardFontEmbedder";
    PDFClasses["PDFArray"] = "PDFArray";
    PDFClasses["PDFButton"] = "PDFButton";
    PDFClasses["PDFCheckBox"] = "PDFCheckBox";
    PDFClasses["PDFDropdown"] = "PDFDropdown";
    PDFClasses["PDFOptionList"] = "PDFOptionList";
    PDFClasses["PDFRadioGroup"] = "PDFRadioGroup";
    PDFClasses["PDFSignature"] = "PDFSignature";
    PDFClasses["PDFTextField"] = "PDFTextField";
    PDFClasses["PDFField"] = "PDFField";
    PDFClasses["PDFRef"] = "PDFRef";
    PDFClasses["PDFAcroForm"] = "PDFAcroForm";
    PDFClasses["PDFAcroField"] = "PDFAcroField";
    PDFClasses["PDFAcroNonTerminal"] = "PDFAcroNonTerminal";
    PDFClasses["PDFAcroPushButton"] = "PDFAcroPushButton";
    PDFClasses["PDFAcroCheckBox"] = "PDFAcroCheckBox";
    PDFClasses["PDFAcroComboBox"] = "PDFAcroComboBox";
    PDFClasses["PDFAcroListBox"] = "PDFAcroListBox";
    PDFClasses["PDFAcroText"] = "PDFAcroText";
    PDFClasses["PDFAcroRadioButton"] = "PDFAcroRadioButton";
    PDFClasses["PDFAcroSignature"] = "PDFAcroSignature";
    PDFClasses["AESBaseCipher"] = "AESBaseCipher";
    PDFClasses["PDFBool"] = "PDFBool";
    PDFClasses["PDFRawStream"] = "PDFRawStream";
    PDFClasses["PDFContentStream"] = "PDFContentStream";
    PDFClasses["Segment"] = "Segment";
    PDFClasses["Rectangle"] = "Rectangle";
    PDFClasses["Arc"] = "Arc";
    PDFClasses["Circle"] = "Circle";
    PDFClasses["Ellipse"] = "Ellipse";
    PDFClasses["Line"] = "Line";
    PDFClasses["Plot"] = "Plot";
    PDFClasses["Point"] = "Point";
    PDFClasses["PDFPageTree"] = "PDFPageTree";
    PDFClasses["PDFInvalidObject"] = "PDFInvalidObject";
    PDFClasses["PDFCatalog"] = "PDFCatalog";
    PDFClasses["DefaultDocumentSnapshot"] = "DefaultDocumentSnapshot";
    PDFClasses["PDFObjectStream"] = "PDFObjectStream";
    PDFClasses["IncrementalDocumentSnapshot"] = "IncrementalDocumentSnapshot";
    PDFClasses["PDFNull"] = "PDFNull";
})(PDFClasses || (PDFClasses = {}));
/**
 * Replaces instanceof operator by a "secure function" that uses clases internal identification.
 * This allows complex environments, where objects comes from different library instances, to work as expected.
 * @param {any} object Object to which compare the classname.
 * @param {PDFClasses | typeof PDFClass} className Class name object is expected to be an instanca (or subclass instance)
 * @returns {boolean}
 */
export const isPDFInstance = (object, className) => {
    if (!object)
        return false;
    if (!object.myClass)
        return false; // it's not an object from this library
    if (typeof className === 'function') {
        // is a constructor (PDFnNumber, PDFDict, etc)
        try {
            return isPDFInstance(object, className.className());
        }
        catch (error) {
            return false;
        }
    }
    if (object.myClass() === className)
        return true;
    // not a perfect match, check superclasses
    let proto = Object.getPrototypeOf(object);
    while (proto && proto.constructor.className) {
        try {
            if (proto.constructor.className() === className)
                return true;
            proto = Object.getPrototypeOf(proto);
        }
        catch (error) {
            return false;
        }
    }
    // not the class, nor a subclass
    return false;
};
//# sourceMappingURL=objects.js.map